var map = {
	"./ar.svg": "48c6",
	"./cs.svg": "01ea",
	"./en.svg": "7347",
	"./es.svg": "fa30",
	"./he.svg": "ba87",
	"./ka.svg": "b394",
	"./ml.svg": "f167",
	"./nl.svg": "dfa3",
	"./pl.svg": "a01f",
	"./pt.svg": "f689",
	"./ro.svg": "e46f",
	"./ru.svg": "40106",
	"./si.svg": "dc41",
	"./sk.svg": "aba3",
	"./uk.svg": "abb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9149";